import { useEffect, useState, useCallback } from "react";
import api from "../../lib/api";
import { PageHeader, Table, Td, StatusBadge, EmptyState } from "../../components/dashboard/Shared";

const FILTERS = ["", "success", "failed", "skipped"];

export default function Executions() {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("");

  const load = useCallback(() => {
    api.get(`/signals/executions/all?status=${filter}`).then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [filter]);
  useEffect(() => {
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div>
      <PageHeader title="Execution Logs" sub="Every signal execution: successes, failures, retries, margin and connection errors" />
      <div className="flex gap-2 mb-5">
        {FILTERS.map((f) => (
          <button key={f || "all"} data-testid={`exec-filter-${f || "all"}`} onClick={() => setFilter(f)}
            className={`px-4 py-1.5 rounded-lg text-sm capitalize transition-colors ${filter === f ? "bg-[#7000FF]/20 text-[#00F0FF] border border-[#7000FF]/40" : "text-gray-400 border border-white/10 hover:text-white"}`}>
            {f || "all"}
          </button>
        ))}
      </div>
      {!rows ? <div className="skeleton h-96" /> : rows.length === 0 ? (
        <EmptyState title="No executions yet" sub="Execution logs appear when signals are dispatched to client accounts." />
      ) : (
        <Table headers={["Time", "Client", "Account", "Signal", "Lots", "Status", "Retries", "Error Type", "Details", "ms"]} testId="executions-table">
          {rows.map((e) => (
            <tr key={e.exec_id} className="border-b border-white/5 hover:bg-white/[0.02]">
              <Td className="tabular text-xs text-gray-500">{String(e.created_at).slice(5, 19).replace("T", " ")}</Td>
              <Td className="text-xs">{e.client_name || e.user_id}</Td>
              <Td className="tabular text-xs">{e.broker} · {e.login}</Td>
              <Td className="text-xs"><span className="tabular text-white">{e.symbol || "ALL"}</span> <span className="text-gray-500">{e.signal_type?.replace("_", " ")}</span></Td>
              <Td className="tabular text-xs">{e.lots ?? "—"}</Td>
              <Td><StatusBadge status={e.status === "success" ? "paid" : e.status === "failed" ? "overdue" : "pending"} /> <span className="text-[10px] text-gray-500">{e.status}</span></Td>
              <Td className="tabular text-xs">{e.retries ?? 0}</Td>
              <Td className="text-xs text-gray-500">{e.error_type || "—"}</Td>
              <Td className="text-xs !whitespace-normal max-w-xs text-gray-500">{e.status === "success" ? (e.order_id ? `Order ${e.order_id}` : "OK") : (e.error || "").slice(0, 140)}</Td>
              <Td className="tabular text-xs text-gray-600">{e.duration_ms ?? "—"}</Td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
